/* Çeviriler HubApi'den (Translation tablosu) gelir; eski anahtarlar vue-i18n 8 için yazıldı, yenileri
   Estesoft.App locale dosyalarından (vue-i18n 9 sözdizimi) senkronlanır. vue-i18n 9 metni derler ve
   `{` `}` `@` `|` karakterlerini sözdizimi sayar: e-posta adresi linked message, `|` çoğul ayırıcı (`$t`
   ilk parçayı döner), eşleşmeyen süslü parantez derleme hatası olur. İki sürümde de aynı anlama gelen
   kalıplar olduğu gibi kalır: `{ad}`/`{0}` ve `%{ad}` yer tutucuları (8'deki gibi boşluksuz), `@:anahtar` / `@.değiştirici:anahtar`
   bağlantıları ve 9'un literal yazımı `{'@'}`. Kalan özel karakterler literal yazılır; veritabanı değişmez.
   Lokal HubApi verisinde (28.09.2026) dönüştürülen değer yok: 704 yer tutucu, 43 `%{…}`, 2 `{'@'}`. */
const KEPT_SYNTAX = /^(?:%?\{\w+\}|\{\s*'[^']*'\s*\}|@(?:\.[a-zA-Z]+)?:[\w\-_.]+)/;

export function toVueI18n9Message(message) {
  if (typeof message !== 'string' || !/[{}@|]/.test(message)) return message;

  let result = '';
  for (let index = 0; index < message.length; index++) {
    const char = message[index];
    const kept = (char === '{' || char === '%' || char === '@') && message.slice(index).match(KEPT_SYNTAX);
    if (kept) {
      result += kept[0];
      index += kept[0].length - 1;
    } else if (char === '{' || char === '}' || char === '@' || char === '|') {
      result += `{'${char}'}`;
    } else {
      result += char;
    }
  }
  return result;
}

export function toVueI18n9Messages(messages) {
  if (typeof messages === 'string') return toVueI18n9Message(messages);
  if (!messages || typeof messages !== 'object') return messages;

  const converted = Array.isArray(messages) ? [] : {};
  Object.keys(messages).forEach(key => {
    converted[key] = toVueI18n9Messages(messages[key]);
  });
  return converted;
}
